export const UPLOAD_MODAL = 'upload-widget-modal'
export const ROLE_SPECIFIC_MODALS = 'role-specific-modals'
